import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Styles - Chart.js (standalone)
import "chart.js";

// Styles - Calendar & Icons
import "@fullcalendar/core/main.css";
import "@fullcalendar/timegrid/main.css";
import "@fortawesome/fontawesome-free/css/all.css";

// Theme
import "@/theme/Base.scss";

// Configuration
import configureAxios from "@/config/axios";
import installPlugins from "@/plugins";
import registerGlobalComponents from "@/components/global";
import "./registerServiceWorker";

// Configure application
Vue.config.productionTip = false;

// Event bus for component communication
export const eventBus = new Vue();

// Setup plugins and components
configureAxios();
installPlugins();
registerGlobalComponents();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount("#app");
